import http, { garantirCookieCsrf } from "./http";

/**
 * SALVIA-744: o login abre uma sessão por cookie httpOnly. A resposta pode
 * ainda trazer `access_token` durante a transição do backend — o front novo o
 * IGNORA de propósito: guardá-lo seria recriar o problema que a task resolve.
 */
export async function loginRequest(email, password) {
  // Cookie de CSRF novo antes do login: o Laravel troca o id da sessão ao
  // autenticar, e começar com um token fresco evita um 419 na primeira tela.
  await garantirCookieCsrf({ forcar: true });
  const { data } = await http.post("/api/login", { email, password });
  return data;
}

/**
 * Quem está logado. `sondagem: true` quando a pergunta é "ainda tenho
 * sessão?" — aí o 401 é resposta esperada e não manda para o login.
 */
export async function fetchMe({ sondagem = false } = {}) {
  const { data } = await http.get("/api/user", { _sondagem: sondagem });
  return data;
}

export async function exchangeGoogleCode(code) {
  await garantirCookieCsrf({ forcar: true });
  const { data } = await http.post("/api/auth/google/login/exchange", { code });
  return data; // { needs_role }
}
